import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import useUpdateMode from '@hooks/useUpdateMode'
import { saveAnswer } from '@utils/onboardingStorage'
import { useTranslation } from 'react-i18next'
import { useSearchParams, useSubmit } from 'react-router-dom'

const QUESTION_KEY = 'suggestions'

const OPTIONS = [
  {
    value: 'Objective',
    translationKey: 'pages.onboarding.suggestions.options.objective',
    subtextKey: 'pages.onboarding.suggestions.subtexts.objective',
  },
  {
    value: 'Encouraging',
    translationKey: 'pages.onboarding.suggestions.options.encouraging',
    subtextKey: 'pages.onboarding.suggestions.subtexts.encouraging',
  },
  {
    value: 'Reflective',
    translationKey: 'pages.onboarding.suggestions.options.reflective',
    subtextKey: 'pages.onboarding.suggestions.subtexts.reflective',
  },
  {
    value: 'Surprise me',
    translationKey: 'pages.onboarding.suggestions.options.surprise',
    subtextKey: '', // no subtext
  },
]

export default function SuggestionsPage() {
  const submit = useSubmit()
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value')
  const preselectedValue =
    value && OPTIONS.some((option) => option.value === value)
      ? value
      : undefined
  const { isUpdate, postToReactNative } = useUpdateMode()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    // Get the answer value from the form
    const formData = new FormData(event.currentTarget)
    const value = formData.get('answer') as string

    if (!value) return

    const answer = {
      question_key: QUESTION_KEY,
      question: 'What kind of suggestions do you prefer?',
      answer_key: value,
      answer: value,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(event.currentTarget)
    }
  }

  // Transform options to the format expected by QuestionPage
  const buttons = OPTIONS.map((option) => ({
    text: t(option.translationKey),
    subtext: t(option.subtextKey),
    value: option.value,
  }))

  return (
    <QuestionPage
      heading={t('pages.onboarding.suggestions.heading')}
      buttons={buttons}
      onSubmit={handleSubmit}
      headingSize="text-3xl text-center whitespace-pre-line"
      buttonTextSize="text-xl"
      buttonBgColor="bg-white"
      preselectedValue={preselectedValue}
    />
  )
}
